import http from 'lib/http';
export var urlgetVoteInfo = '/api/XOrg/CourseSectionIndex/getVoteInfo';
export function getVoteInfo(Id) {
  return http.post(urlgetVoteInfo, {
    Id: Id
  });
}